module.exports = __webpack_public_path__ + "a1cce05d7a476211f16bdc2e93802664.png";